import manifest from '../data/publicUrlManifest.json';

export const SITE_ORIGIN = manifest.origin;
const pagePaths = new Map(manifest.routes.map(({ path, canonical }) => [path, canonical]));
const articlePaths = new Map(Object.entries(manifest.articleSlugs));
const withoutSlash = (path) => path === '/' ? '/' : path.replace(/\/$/, '');

// Only pages in the reviewed inventory are normalized. Files, API/admin URLs,
// unknown paths, external links, protocol links and fragment-only links survive.
export function publicHref(value) {
  if (typeof value !== 'string') return value;
  const absolute = /^(https?:\/\/[^/?#]+)(\/[^?#]*)?([?#].*)?$/.exec(value);
  let pathAndSuffix = value;
  if (absolute) {
    if (!/^https?:\/\/(www\.)?deltavalleyhealthclub\.com$/i.test(absolute[1])) return value;
    pathAndSuffix = (absolute[2] || '/') + (absolute[3] || '');
  } else if (!value.startsWith('/') || value.startsWith('//')) {
    return value;
  }
  const match = /^([^?#]*)([?#].*)?$/.exec(pathAndSuffix);
  const path = withoutSlash(match[1]);
  const preferred = pagePaths.get(path) || manifest.linkRepairs[path];
  if (!preferred) return value;
  return (absolute ? SITE_ORIGIN : '') + preferred + (match[2] || '');
}

export function canonicalForPath(pathname) {
  const path = withoutSlash(pathname);
  let preferred = pagePaths.get(path);
  // The existing article router looks up the slug, even for a differently dated
  // URL. Always identify the article by its retained wp_path, not an invented date.
  if (!preferred) {
    const dated = /^\/\d{4}\/\d{2}\/\d{2}\/([^/]+)$/.exec(path);
    if (dated) preferred = articlePaths.get(dated[1]);
  }
  return preferred ? SITE_ORIGIN + preferred : null;
}

export function normalizeSchemaUrls(value) {
  if (Array.isArray(value)) return value.map(normalizeSchemaUrls);
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, normalizeSchemaUrls(item)]));
  }
  return typeof value === 'string' && /^https?:\/\//.test(value) ? publicHref(value) : value;
}
